import { ref } from '@vue/composition-api'
import { isNavLinkActive } from '@core/layouts/utils'
import router from '@/router'

export default function useHorizontalNavMenuHeaderGroup(item) {
  // ------------------------------------------------
  // isActive
  // ------------------------------------------------
  const isActive = ref(false)

  const updateIsActive = () => {
    const isType = String(router.currentRoute.query?.type) === String(item.id)
    isActive.value = Number(router.currentRoute.query?.type) ? isNavLinkActive(item) && isType : Number(item.id)===0
  }

  return {
    isActive,
    updateIsActive,
  }
}
